import { SetURLSearchParams } from 'react-router-dom';

type RevenueFilterHandlerProps = {
  searchParams: URLSearchParams;
  filterParams: Record<string, string>;
  setSearchParams: SetURLSearchParams;
};

export const getRevenueFilterHandler = ({
  filterParams,
  setSearchParams,
}: RevenueFilterHandlerProps): {
  handleFilterReset: () => void;
  handleFilterSubmit: () => void;
} => {
  const handleFilterSubmit = (): void => {
    setSearchParams(prev => {
      return {
        ...prev,
        ...filterParams,
      };
    });
  };

  const handleFilterReset = (): void => {
    setSearchParams({
      start_yearmon: ['2022-01'],
      end_yearmon: ['2025-01'],
      group_by: ['yearmon'],
    });
  };

  return {
    handleFilterReset,
    handleFilterSubmit,
  };
};
